import keyMirror from '../common/keyMirror';
export default keyMirror({
  LOAD_SUCCESS: null,
  UPDATE_START: null,
  UPDATE_CANCEL: null,
  UPDATE_SUBMIT: null,
  UPDATE_SUCCESS: null,
  RESET_SUBMIT: null,
  RESET_SUCCESS: null,
  FAIL: null,
  LOAD_FAIL: null,
  CLEAR_FAIL: null
}, 'PASSWORD_');